import type { ReactElement } from 'react';
import { IssueSeverity, type ComplianceIssue } from '@gr/core/distribution/channels/compliance';
import { useT } from '../../../../app/di';
import { Badge } from '../../../../ui-kit/Badge/Badge';

/** CHN-UC-4, POST-UC-7: замечания к публикации по правилам канала. */
export function IssueList({ issues }: { issues: readonly ComplianceIssue[] }): ReactElement {
  const { t } = useT();
  return (
    <ul className="u-bullets">
      {issues.map((issue, index) => (
        <li key={`${issue.code}-${index}`} className="u-small">
          <Badge tone={issue.severity === IssueSeverity.Warning ? 'warning' : 'neutral'}>{t(`channels.compliance.issues.${issue.code}`, issue.params)}</Badge>
        </li>
      ))}
    </ul>
  );
}
